export class WFXIdReqDto {
    wfxId: number;
    constructor(
        wfxId: number
    ) {
        this.wfxId = wfxId;
    }
}